import { RestrictedByTooltip } from "components";
import { PaywallModalTypes } from "components/restrictedByAddOn/paywallModal/types";
import RestrictedByAddOn from "components/restrictedByAddOn/RestrictedByAddOn";
import { RolePermissions } from "enums";
import { useNavigate } from "react-router";
import { Button } from "semantic-ui-react";

export const CreateEmbeddedVideoButton = () => {
  const navigate = useNavigate();

  const onClick = () => navigate("create");
  const renderButton = (action: () => void, hasAnyPermission: boolean): React.ReactElement => (
    <RestrictedByTooltip hasPermission={hasAnyPermission}>
      <Button primary onClick={action} disabled={!hasAnyPermission} className="create-button">
        Embed Video
      </Button>
    </RestrictedByTooltip>
  );

  return (
    <RestrictedByAddOn
      permissions={[RolePermissions.AssetsManage, RolePermissions.AssetsCreate]}
      addOnPermissions={[RolePermissions.AssetsCreate]}
      modalType={PaywallModalTypes.UpgradeToCreateContent}
      action={onClick}
      renderContent={renderButton}
    />
  );
};
